var paper = require("paper");

if (typeof window.paper !== "undefined") {
    paper = window.paper;
}
module.exports = paper;


//////////////////
// WEBPACK FOOTER
// ../animatePaper.js/src/getPaper.js
// module id = 5
// module chunks = 0 1 2 3 4 5 6